<template>
    <v-flex xs12 sm12 d-block class="card-dados card-dados__mobile">
        <h3 class="card-dados__titulo mb-0">Notificar Fornecedores por E-mail</h3>

        <v-data-table :headers="colunas" :items="value"
                      no-data-text="Não há e-mails adicionados"
                      class="az-table-list tabela-email">
            <template slot="items" slot-scope="props">
                <td>
                    {{ props.item.email }}
                </td>
            </template>
        </v-data-table>
    </v-flex>
</template>

<script>
export default {
    name: 'PainelConvidadoVisualizacao',
    props: {
        value: {
            required: true
        }
    },
    data() {
        return {
            colunas: [
                {
                    text: 'E-mail',
                    value: 'email',
                    sortable: true,
                    align: 'left',
                    width: '100%',
                    class: 'primary--text'
                }
            ]
        }
    }
}
</script>

<style scoped lang="stylus">
    .tabela-email
        padding 16px

    @media (max-width 720px)
        .tabela-email
            padding 0

            td:nth-of-type(1):before
                content "E-mail:"
</style>